/*
 * @Author       : 秦灵
 * @desc         : 组件描述
 * @Date         : 2025-01-13 15:17:29
 * @LastEditTime : 2025-01-14 10:00:10
 * @LastEditors  : 秦灵
 * @FilePath     : /evalute-all/teaching_QualityService/src/store/index.js
 */
/*
 * @Author: wangyuanqin
 * @desc: 智慧就业-指导网
 * @Date: 2020-08-07 17:36:42
 * @LastEditTime: 2020-09-07 13:58:37
 * @LastEditors: wangyuanqin
 * @FilePath: \teaching_QualityService\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import aside from './modules/aside'
import projectRange from './modules/projectRange'
import getters from './getters'
import zzbg from './modules/zzbg'
import progress from './modules/progress'
import card from './modules/card'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        app,
        aside,
        projectRange,
        zzbg,
        progress,
        card
    },
    getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js